import PastEvent from './PastEvent';

export default PastEvent;
